import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 获取区域列表
export const getcarList = params => {
    return get("/admin/carpark", params);
};
// 新增区域
export const addCar = params => {
    return post("/admin/carpark", params);
};
// 修改区域信息
export const editCar = params => {
    return put(`/admin/carpark/${params.id}`, params);
};
// 删除区域
export const deleteCar = params => {
    return del(`/admin/carpark/${params}`);
};

//获取楼层列表
export const getFloor = params => {
    return get(`/admin/carpark/detail/${params}`);
};
// 添加修改
export const editCarList = params => {
    return post("/admin/carpark/edit", params);
};
// 删除楼层
export const deletefloor = params => {
    return del(`/admin/floor/${params}`);
};
// 删除分区
export const deletearea = params => {
    return del(`/admin/area/${params}`);
};
// 绘图
export const drawPic = params => {
    return post("/admin/carpark/darw", params);
};
// 咨询类型列表
export const getAskTypeList = () => {
	return get("/admin/floor/askType/list");
}
// 获取车位类型列表
export const getCaportTypeList = params => {
	return get("/admin/carportAttribute/carportTypes", params);
}


// WEBPACK FOOTER //
// ./src/api/garage.js